<template>
    <div>
        <div class="form-group row">
            <label class="col-sm-4 col-form-label" for="dealsAutocomplete" v-bind:class="{'required' : requiredFields && requiredFields.includes('deal')}">Affaire</label>
            <div class="col-sm-8">
                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" v-bind:class="{'is-invalid' : jsonError && jsonError.deal_id}" id="dealsAutocomplete" type="text" v-model="deal.designation">
                 <input type="hidden" v-if="deal != null" :value="deal.id" id="deal_id" name="deal_id">
                 <input type="hidden" v-if="deal != null" :value="JSON.stringify(deal)" id="deal" name="deal">
                 <div class="invalid-feedback" v-if="jsonError && jsonError.deal_id">{{ jsonError.deal_id[0] }}</div>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-4 col-form-label" for="lotsAutocomplete" v-bind:class="{'required' : (requiredFields && requiredFields.includes('lot') || (operation && operation.id))}">Lot</label>
            <div class="col-sm-8">
                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" v-bind:class="{'is-invalid' : jsonError && jsonError.lot_id}"  id="lotsAutocomplete" type="text" v-model="lot.designation" :required="(requiredFields && requiredFields.includes('lot')) || (operation && operation.id)">
                <input type="hidden" :value="lot ? lot.id : null" id="lot_id" name="lot_id">
                <input type="hidden" :value="JSON.stringify(lot)" id="lot" name="lot">
                <div class="invalid-feedback" v-if="jsonError && jsonError.lot_id">{{ jsonError.lot_id[0] }}</div>
            </div>
        </div>

        <div class="form-group row" v-show="lot.designation">
            <label for="operation" class="col-sm-4 col-form-label">Opération</label>
            <div class="col-sm-8">
                <select class="form-control mt-2" v-model="operation" id="operation" v-bind:class="{'is-invalid' : jsonError && jsonError.operation_id}" :disabled="operations == null">
                    <option v-for="(item, index) in operations" :key="index" :value="item">{{ item.designation }}</option>
                </select>
                <input type="hidden" :value="(lot && operation) ? operation.id : null" id="operation_id" name="operation_id">
                <input type="hidden" :value="JSON.stringify(operation)" id="operation" name="operation">
                <input type="hidden" :value="JSON.stringify(operations)" id="operations" name="operations">
                <div class="invalid-feedback" v-if="jsonError && jsonError.operation_id">{{ jsonError.operation_id[0] }}</div>
            </div>
        </div>
    </div>
</template>

<script>

/*
    requiredFields : ['deal' , 'lot' , 'operation']
    errors : key => ['deal_id' , 'lot_id' , 'operation_id']
*/
export default {
    name: 'deal-lot-operation',
    props: ['dealsRoute' , 'lotsRoute', 'initialData' ,'oldData',  'errors' , 'requiredFields'],
    data(){
        return {
            deal: {
                id: null,
                designation: null
            },
            lot: {
                id: null,
                designation: null
            },
            operation: null,
            operations: null,
            jsonData: null,
            jsonError: null,
        }
    },
    watch: {
        'lot.designation'(newVal) {
            if (newVal == '' || newVal == null) {
                this.lot.id = null
                this.operations = null
                this.operation = null
            }
        },
    },
    methods: {
        initForm: function(){
            const jsonDataBackup = JSON.parse(this.oldData)


            if (Array.isArray(jsonDataBackup)) {
                this.jsonData = JSON.parse(this.initialData)
            } else {
                jsonDataBackup.deal = JSON.parse(jsonDataBackup.deal);
                if(jsonDataBackup.lot != null){
                    jsonDataBackup.lot = JSON.parse(jsonDataBackup.lot)
                }
                if(jsonDataBackup.operation != null){
                    jsonDataBackup.operation = JSON.parse(jsonDataBackup.operation)
                }
                if(jsonDataBackup.operations != null){
                    jsonDataBackup.operations = JSON.parse(jsonDataBackup.operations)
                }
                this.jsonData = jsonDataBackup
            }

            this.deal.id = this.jsonData.deal ? this.jsonData.deal.id : null;
            this.deal.designation = this.jsonData.deal ? this.jsonData.deal.designation : null;

            this.lot.id = this.jsonData.lot != null ? this.jsonData.lot.id : null;
            this.lot.designation = this.jsonData.lot != null ? this.jsonData.lot.designation : null;

            this.operation = this.jsonData.operation != null ? this.jsonData.operation : null;
            this.operations = this.jsonData.operations != null ? this.jsonData.operations : null;

            this.jsonError = JSON.parse(this.errors);

        },
        initInput: function(){
            $("#dealsAutocomplete").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.dealsRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: {q: request.term},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                    deal_designation: item.designation,
                                    deal_id: item.id
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if (!item.item) {
                        $(e.target).val("");
                        this.deal.id = null;
                        this.deal.designation = null;
                        this.operations = null;
                        this.operation = null;
                        this.lot.id = null;
                        this.lot.designation = null;
                    }
                },
                select: (e, item) => {
                    if(item.item){
                        this.deal.designation = item.item.designation;
                        this.deal.id = item.item.id;
                         
                        this.lot.id = null;
                        this.lot.designation = null;
                        this.operations = null;
                        this.operation = null;
                    }          
                }
            }).focus(() => {
                $("#dealsAutocomplete").autocomplete("search", '');
            });

            $('#lotsAutocomplete').autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url: this.lotsRoute,
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: {q: request.term , deal_id: this.deal ? this.deal.id : null},
                         success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                    lot_designation: item.designation,
                                    lot_id: item.id,
                                });
                            }))
                        }
                    })
                },
                change: (e, item) => {
                    if (!item.item) {
                        $(e.target).val("")
                        this.lot.id = null;
                        this.lot.designation = null;
                        this.operations = null;
                        this.operation = null;
                    }
                },  
                select: (e, item) => {
                    if(item.item){
                        this.operations = item.item.operations;
                        this.operation = null

                        if(this.operations.length > 0){
                            this.operation = this.operations[0]
                        }

                        this.lot.id = item.item.id;
                        this.lot.designation = item.item.designation;

                        this.deal.designation = item.item.deal.designation;
                        this.deal.id = item.item.deal.id;
                    }
                }
            }).focus(() => {
                $('#lotsAutocomplete').autocomplete("search", '');
            })
        }
    },
    mounted(){
       this.initForm();
       this.initInput();
    }
}
</script>